import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import Home from './Home';
import Login from './Login';
import LoginReceiver from './LoginReceiver';
import NoMatch from '../components/NoMatch';
import Logout from '../components/Logout';
import PrivateRoute from '../components/PrivateRoute';

const MainRouter = props => {
  const {
    isAdmin,
    isLoggedIn,
  } = props;

  return (
    <Switch>
      <Route exact path="/" render={rest => (<Login {...rest} isLoggedIn={isLoggedIn} />)}/>
      <Route path="/authorizing" render={rest => (<LoginReceiver {...rest}/>)}/>
      <PrivateRoute path="/home" component={Home} isAdmin={isAdmin} {...props}/>
      <Route path="/logout" render={rest => <Logout {...rest} />}/>
      <Route component={NoMatch} />
    </Switch>
  );
};
export default MainRouter;

MainRouter.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};
